import {
    VIDFLEET_POWER_LOST_REQUEST,
    VIDFLEET_POWER_LOST_RESULT,
} from 'Redux/actionTypes';

export const powerLostRequest = (filters) => ({
    type: VIDFLEET_POWER_LOST_REQUEST,
    payload: { filters }
});

export const powerLostResult = (data) => ({
    type: VIDFLEET_POWER_LOST_RESULT,
    payload: data
});